<template>
  <div ref="appLanguageRef" class="relative">
    <button
      class="flex items-center justify-center w-9 h-9 rounded-full bg-primary/10 cursor-pointer overflow-hidden"
      @click="toggle"
      :name="locale === 'hy' ? 'Ընտրել լեզուն' : 'Select language'"
      :aria-label="locale === 'hy' ? 'Ընտրել լեզուն' : 'Select language'"
    >
      <img
        v-if="selectedLanguageFlag"
        :src="selectedLanguageFlag"
        class="rounded-full h-full w-full object-cover"
        :alt="selectedLanguageName"
      />
      <Icon name="heroicons:globe" v-else size="20" />
    </button>
    <Transition enter-active-class="fadeIn" leave-active-class="fadeOut">
      <div
        v-if="open"
        class="absolute right-0 top-13 w-50 p-2.5 rounded-lg bg-white border border-gray-200 shadow-xl z-50"
      >
        <div class="p-1">
          <div
            @click="selectAppLanguage(lang.code)"
            :class="{
              'bg-primary-blue/5 text-primary-blue': locale === lang.code,
            }"
            class="flex items-center justify-between cursor-pointer px-3 py-2 my-1 rounded hover:bg-gray-100"
            v-for="lang in languages"
            :key="lang.code"
          >
            <div class="flex items-center space-x-3">
              <img
                v-if="lang.flag"
                :src="lang.flag"
                :alt="$t(`languages.` + lang.code)"
              />
              <p>{{ $t("languages." + lang.code) }}</p>
            </div>
            <Icon
              v-if="locale === lang.code"
              name="heroicons:check"
              class="text-primary-blue"
              size="20"
            />
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import hyIcon from "@/assets/images/flags/am.svg";
import enIcon from "@/assets/images/flags/en-us.svg";
import ruIcon from "@/assets/images/flags/ru.svg";

import { useI18n, type Locale } from "vue-i18n";

const { locale, t, setLocale } = useI18n();

const open = ref<boolean>(false);
const appLanguageRef = ref<HTMLElement | null>(null);

export interface LanguageItem {
  title: string;
  code: Locale;
  flag: string | null;
}

const languages = shallowRef<LanguageItem[]>([
  { title: "Armenian", code: "hy", flag: hyIcon },
  { title: "English", code: "en", flag: enIcon },
  { title: "Russian", code: "ru", flag: ruIcon },
]);

const selectedLanguageFlag = computed<string>(
  () => languages.value.find((item) => item.code === locale.value)?.flag || "",
);

const selectedLanguageName = computed<string>(() =>
  t("languages." + locale.value),
);

const toggle = () => (open.value = !open.value);

const selectAppLanguage = async (code: Locale) => {
  if (!code) return;

  await setLocale(code);

  open.value = false;
};
onClickOutside(appLanguageRef, () => (open.value = false));
</script>
